module.exports = __webpack_public_path__ + "static/media/logo-sky.3215a062.png";